module.exports = __webpack_public_path__ + "assets/img/bg.c46ff8fe.png";